export default __webpack_public_path__ + "static/media/mus1.234bb5f4.jpeg";